module.exports = __webpack_public_path__ + "img/fantasque-sans-mono-light.aa3a6091.png";